import React from 'react';

const Indiana = () => {
  return (
    <div>
      <h2 className="text-xl font-bold uppercase mt-8 mb-2 border-b pb-1">
        Indiana Specific Terms
      </h2>
      <ol className="text-black mb-4 text-base list-decimal list-inside">
        <li>Residential Real Estate Sales Disclosure form required.</li>
        <li>
          <span
            className="underline text-blue-500 hover:text-blue-700 cursor-pointer"
            onClick={() => {
              window.open(
                'https://eforms.com/images/2015/09/sellers-disclosure-of-lead-paint.pdf',
                '_blank'
              );
            }}
          >
            Lead-Based Paint Disclosure{' '}
          </span>{' '}
          – Only for residences that were built before 1978. This information
          should be available at the County’s Revenue Office.
        </li>
        <li>
          <span
            className="underline text-blue-500 hover:text-blue-700 cursor-pointer"
            onClick={() => {
              window.open(
                'https://eforms.com/images/2018/08/Indiana-Sellers-Residential-Property-Disclosure-Form.pdfs',
                '_blank'
              );
            }}
          >
            Seller's Residential Real Estate Sales Disclosure (Form 46234){' '}
          </span>{' '}
          – This comprehensive disclosure must be completed by the seller to
          inform the buyer of any known defects or issues.
        </li>
      </ol>
    </div>
  );
};

export default Indiana;
